import Calendar from '../calendar/Calendar';
import dayjs from 'dayjs';

export const WizardSlides = account => {
  const firstConnectionWithoutEntity = () => {
    return [
      {
        step: 1,
        label: 'Bienvenue chez Dipeeo.',
        title: `Bienvenue ${account.companyName} sur votre espace RGPD Dipeeo.`,
        content: "Nous sommes fiers d'être votre partenaire de confiance pour votre mise en conformité RGPD.",
        input: false,
        inputType: 'text',
        options: [],
        buttonLabel: 'DÉMARRER',
        conditions: [],
      },
      {
        step: 2,
        label: 'Pour bien commencer',
        title: 'Pour bien commencer',
        content: 'Quelle est le nom de votre première entité ?',
        input: true,
        inputType: 'text',
        options: [],
        buttonLabel: 'SUIVANT',
        conditions: [],
      },
      {
        step: 3,
        label: 'Merci !',
        title: 'Merci !',
        content: (
          <div>
            Vous allez maintenant être redirigé vers votre tableau de bord.
            <br />
            Nous vous invitons à ajouter les produits associés à votre entité (application en ligne/mobile, site internet, Blog ou FAQ) et à répondre
            aux questionnaires associés !
          </div>
        ),
        input: false,
        inputType: 'text',
        options: [],
        buttonLabel: 'ACCEDER AU TABLEAU DE BORD',
        conditions: [],
      },
    ];
  };

  const firstConnectionWithEntity = () => {
    return [
      {
        step: 1,
        label: 'Bienvenue chez Dipeeo.',
        title: `Bienvenue ${account.companyName} sur votre espace RGPD Dipeeo.`,
        content: "Nous sommes à nouveau fiers d'être votre partenaire de confiance pour votre mise en conformité RGPD.",
        input: false,
        inputType: 'text',
        options: [],
        buttonLabel: 'DÉMARRER',
        conditions: [],
      },
      {
        step: 2,
        label: 'Merci !',
        title: 'Merci !',
        content: (
          <div>
            Vous allez maintenant être redirigé vers votre tableau de bord.
            <br />
            Nous vous invitons à ajouter les produits associés à votre entité (application en ligne/mobile, site internet, Blog ou FAQ) et à répondre
            aux questionnaires associés !
          </div>
        ),
        input: false,
        inputType: 'text',
        options: [],
        buttonLabel: 'ACCEDER AU TABLEAU DE BORD',
        conditions: [],
      },
    ];
  };

  const calendar = (isStepPointInvitation: boolean) => {
    return [
      {
        step: 1,
        label: isStepPointInvitation ? "Votre plan d'actions est prêt !" : 'Bienvenue chez Dipeeo.',
        title: isStepPointInvitation ? "Votre plan d'actions RGPD est prêt !" : `Bienvenue ${account.companyName} sur votre espace RGPD Dipeeo.`,
        content: isStepPointInvitation ? (
          <div>
            Afin de vous présenter l'ensemble des mesures correctives que vous devez mettre en place pour que vous soyez conforme au RGPD, nous vous
            invitons à prendre rendez-vous avec votre DPO.
          </div>
        ) : (
          <div>
            Nous sommes ravis de vous accompagner dans votre mise en conformité RGPD avec Dipeeo.
            <br />
            Pour commencer ce processus, nous vous invitons à choisir un créneau horaire qui vous convient pour notre premier rendez-vous.
            <br />
            Cela nous permettra de mieux comprendre vos besoins et de vous expliquer le déroulement de notre collaboration.
          </div>
        ),
        input: false,
        inputType: 'text',
        options: [],
        buttonLabel: 'DÉMARRER',
        conditions: [!account.activity.appointments.didScheduleFirstAppointment || isStepPointInvitation],
      },
      {
        step: 2,
        label: 'Prendre un RDV.',
        title: `Prendre un RDV.`,
        content: "Nous sommes à nouveau fiers d'être votre partenaire de confiance pour votre mise en conformité RGPD.",
        input: false,
        inputType: 'text',
        options: [],
        buttonLabel: 'SUIVANT',
        conditions: [!account.activity.appointments.didScheduleFirstAppointment || isStepPointInvitation],
        children: Calendar,
      },
      {
        step: 3,
        label: 'Merci !',
        title: 'Merci !',
        content: (
          <div>
            Votre RDV a bien été pris en compte.
            <br />
            Vous pouvez désormais quitter cette page.
          </div>
        ),
        input: false,
        inputType: 'text',
        options: [],
        conditions: [],
      },
    ];
  };
  const appointmentConfirmation = () => {
    const firstAppointment = account.activity.appointments.list[0];
    const formattedSlotStart = dayjs(firstAppointment?.startTime).format('HH:mm');
    const formattedDate = dayjs(firstAppointment?.startTime).format('dddd, D MMMM YYYY');
    return [
      {
        step: 1,
        label: 'Merci !',
        title: 'Merci !',
        content: (
          <div>
            Nous sommes ravis de vous informer que votre rendez-vous a bien été pris le <b>{formattedDate}</b> à <b>{formattedSlotStart}</b>.
          </div>
        ),
        input: false,
        inputType: 'text',
        options: [],
        conditions: [],
      },
    ];
  };

  if (!account) {
    return [];
  }

  let isStepPointInvitationEmailSent = account.users.some(user =>
    user.activity.sentMails.some(email => email.templateId === 'd-cf2a5491a81242a98fd6a103dfedb99e')
  );
  let isStepPointInvitation = isStepPointInvitationEmailSent && !account.activity.appointments.didScheduleStepPointAppointment;
  if (!account.activity.appointments.didScheduleFirstAppointment || isStepPointInvitation) {
    return calendar(isStepPointInvitation);
  }
  if (!account.activatedAt) {
    return appointmentConfirmation();
  }
  return account?.entities?.length >= 1 ? firstConnectionWithEntity() : firstConnectionWithoutEntity();
};
